import Vue from 'vue'
import qs from 'qs'
import Validate from '@/utils/validate'
import eventMixin from '@/utils/mixins/eventMixin.js'
import navigateMixin from '@/utils/mixins/navigateMixin.js'
import { gotoFundDetail } from '@/utils/routerUtils'

export default function (router, routes) {
  //添加混入
  Vue.mixin(eventMixin) // 处理路由跳转回调
  Vue.mixin(navigateMixin) // 处理路由跳转行为记录

  // 重写router方法
  let back = router.back
  router.back = function (...args) {
    router.isBack = true
    router.clickRoute = true // 标记为使用内部的点击事件返回 ios 侧滑时此值应该为false
    let argsNew = args
    let cb = args.slice(0, 1)
    if (typeof cb === 'function') {
      let name = router.preRoute()
      router.addEvent(name, cb)
      argsNew = args.slice(1)
    }
    return back.apply(router, argsNew)
  }

  // 重写go方法
  let go = router.go
  router.go = function (...args) {
    router.clickRoute = true // 标记为使用内部的点击事件返回
    let [num] = args
    if (num && num < 0) {
      router.isBack = true
    }
    return go.apply(router, args)
  }

  // 重写push方法
  let push = router.push
  router.push = function (...args) {
    router.clickRoute = true
    let par = args[0]
    // 自定义push动画
    if (par && typeof par === 'object' && par.params && par.params.animate) {
      router.animate = par.params.animate
    }
    let promise = push.apply(router, args)
    if (promise instanceof Promise) {
      return promise.catch(() => {})
    }
    return promise
  }

  // 重写replace方法
  let replace = router.replace
  router.replace = function (...args) {
    router.clickRoute = true
    let par = args[0]
    // 自定义replace动画
    if (par && typeof par === 'object' && par.params && par.params.animate) {
      router.animate = par.params.animate
    }
    let promise = replace.apply(router, args)
    if (promise instanceof Promise) {
      return promise.catch(() => {})
    }
    return promise
  }

  // 获取页面参数
  router.getParams = function (name) {
    let sName = name
    if (!name && this.app && this.app.$route) {
      sName = this.app.$route.name
    }
    let params = sessionStorage.getItem('PAGE_' + sName)
    try {
      return JSON.parse(params)
    } catch (err) {
      return {}
    }
  }

  // 获取所有路由
  router.getRoutes = function () {
    if (!Vue.navigation) return []
    let arr = Vue.navigation.getRoutes()
    // return arr.map((item) => item.replace(/\?.+$/, ''));
    return arr
  }

  // 清除所有路由
  router.cleanRoutes = function () {
    Vue.navigation && Vue.navigation.cleanRoutes()
  }

  // 获取上一个路由
  // n 向前找几位
  router.preRoute = function (n = 1) {
    let arr = router.getRoutes()
    return arr[arr.length - n - 1]
  }

  // 获取之前的路径是否存在此路由，返回与当前路径的距离
  router.hasRouteIndex = function (name) {
    let arr = [...router.getRoutes()]
    arr.reverse()
    if (name === 'Index') {
      return arr.findIndex((item) => item.indexOf(name) === 0)
    }
    return arr.findIndex((item) => item === name)
  }

  // 路由跳转：replace\push
  router.routeTo = function (name, params = {}, query = {}, isReplace) {
    if (isReplace) {
      router.replace({
        name: name,
        params: params,
        query
      })
    } else {
      router
        .push({
          name: name,
          params: params,
          query
        })
        .catch(() => {})
    }
  }

  // 所有的回调方法都挂在这个对象上，k-组件名称，v-函数
  router.pageEvents = {}
  router.addEvent = function (name, fn) {
    router.pageEvents[name] = fn
  }
  router.clearEvent = function (name) {
    if (!name) {
      router.pageEvents = {}
    }
    if (name in router.pageEvents) {
      delete router.pageEvents[name]
    }
  }

  // 页面跳转方法，参数：路径和回调
  router.gotoPage = gotoPage
  // 语法糖 支持字符串和对象
  function gotoPage(options, callback) {
    // 未传参数时处理
    if (Validate.isBlank(options)) {
      return
    }
    //把参数转成对象
    let beforeName = this.app.$route.name
    if (typeof options === 'string') {
      options = coverToObject(options)
    } else if (typeof options === 'object' && options.path) {
      // 如果是对象，并且有path属性，path属性带参数
      options = Object.assign(coverToObject(options.path), options)
      delete options.path
    }
    // 路由里面有name值
    let name = ''
    if ('name' in options) {
      name = options.name
    } else {
      // 路由里面没有name，通过path查找出name
      name = getRouteName(options.path)
    }
    //如果和上一个路由一样，默认返回
    if (router.preRoute() === name) {
      // 如果和上一个路由一样，存在回调
      if (callback) {
        router.addEvent(name, callback)
      }
      return router.back()
    }
    // 要跳转的页面是否
    if (router.hasRouteIndex(name) === 0) {
      return
    }
    // 存在回调
    if (callback) {
      router.addEvent(beforeName, callback)
    }
    // 页面跳转
    if (['FundDetail'].includes(name)) {
      // 先打开一个空白窗口 异步需要这么处理
      const newWindow = window.open('', '_blank')
      gotoFundDetail(options).then((fundCode) => {
        const href = router.resolve({
          name: name,
          params: options.params,
          query: { ...options.query, fundCode }
        }).href
        newWindow.location.href = href
      })
    } else {
      router.routeTo(name, options.params, options.query, options.isReplace)
    }
  }

  //页面返回方法，默认返回上一步
  Vue.$pageBack = Vue.prototype.$pageBack = pageBack
  // 支持数字和字符串
  function pageBack(target) {
    if (typeof target === 'number') {
      router.go(target)
      return
    }
    if (typeof target === 'string') {
      let name = target === '/' ? 'Index' : target
      if (target.indexOf('/') === 0) {
        name = getRouteName(target)
      }
      let num = router.hasRouteIndex(name)
      router.go(-num)
      return
    }
    router.back()
  }

  // 回到tab页
  router.backHome = function (tab, cleanRoute = false, animate = 'back') {
    if (!tab) {
      tab = Vue.$store.getters.tabName
    } else {
      Vue.$store.commit('updateCurrentTab', tab)
    }
    console.log('back home called')
    router.clearEvent()
    router.clearSign()
    router.animate = animate
    pageBack('Index')
    if (cleanRoute) {
      router.cleanRoutes()
    }
  }

  /**
   * 定义一些需要的方法
   */
  // 根据路径获取路由对象
  function getRouteByPath(path) {
    let arr = routes.map((item) => {
      let parLen = 0
      let startPath = item.path
      // 存在:id这样的参数
      let parArr = item.path.match(/:([\w\d]+)/g)
      if (parArr && parArr.length) {
        parArr = parArr.map((item) => item.replace(':', ''))
        parLen = parArr.length
        startPath = item.path.match(/^[^:]+/).toString()
      }
      return {
        ...item,
        startPath: startPath,
        parArr: parArr || [],
        parLen: parLen
      }
    })
    let routeItem = arr.find((item) => {
      if (item.parLen > 0 && path.startsWith(item.startPath)) {
        return true
      }
      return item.path == path
    })
    if (routeItem) {
      return routeItem
    }
  }

  // 根据path[不带?号的path]获取route对象的path和参数
  function getRouteNameAndParams(path) {
    let routeObj = getRouteByPath(path)
    let params = {}
    if (routeObj.parLen > 0) {
      let parStr = path.replace(routeObj.startPath, '')
      let arr = parStr.split('/')
      arr.forEach((item, index) => {
        params[routeObj.parArr[index]] = item
      })
    }
    return {
      name: routeObj.name,
      params: params
    }
  }

  router.getRouteName = getRouteName
  // 根据path获取路由名称
  function getRouteName(path) {
    let item = getRouteByPath(path)
    if (item) {
      return item.name
    }
    return ''
  }

  //把参数转换成对象
  function coverToObject(options) {
    if (typeof options === 'string') {
      // 说明是个路径
      if (options.indexOf('/') === 0) {
        let path = options
        let par = {}
        if (path.indexOf('?') > -1) {
          let arr = path.match(/^([^\\?]+)\??(.*)?$/)
          let [, pathnew, queryStr] = arr
          path = pathnew
          par = qs.parse(queryStr)
        }
        let obj = getRouteNameAndParams(path)
        if (!obj.name) {
          throw new Error('没有找到对应的路由名称')
        }
        options = {
          name: obj.name,
          params: { ...obj.params, ...par },
          query: par
        }
      } else {
        // 是一个名称
        options = {
          name: options
        }
      }
      return options
    }
    return {}
  }

  router.getHistroy = function () {
    let arr = [...router.getRoutes()]
    let newArr = arr.map((item) => {
      return item.split('?')[0]
    })
    const list = routes.filter((obj) => newArr.includes(obj.name))
    let newList = []
    list.forEach((item) => {
      newArr.forEach((items) => {
        if (item.name == items) newList.push(item)
      })
    })
    return newList.reverse()
  }

  return router
}



// WEBPACK FOOTER //
// ./src/routers/routerPlus.js